var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "88",
        "height": "88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "0%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "stroke": "url(#a)",
        "stroke-width": "2",
        "cx": "44",
        "cy": "44",
        "r": "43"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('g', {
      attrs: {
        "fill": "var(--homeIconCenterColor)",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M46.138 51.172c0-3.883 2.773-7.094 6.455-7.8-2.118-3.732-4.203-7.447-6.254-11.094-1.008-1.698-3.48-1.698-4.488 0-3.832 6.757-7.665 13.33-11.48 20.07-1.01 1.698.167 3.883 2.151 3.883h15.431a7.927 7.927 0 01-1.815-5.06zm-2.303-13.146c.823 0 1.496.673 1.496 1.513l-.504 8.086c0 1.176-1.648 1.176-1.816 0l-.504-8.086c0-.84.655-1.513 1.328-1.513zm.151 14.826c-.824 0-1.496-.672-1.496-1.344 0-.84.656-1.513 1.496-1.513.672 0 1.328.672 1.496 1.345 0 .84-.655 1.512-1.496 1.512z"
      }
    }), _c('path', {
      attrs: {
        "d": "M50.301 52.689a3.203 3.203 0 010-4.59 3.363 3.363 0 014.683 0 3.203 3.203 0 010 4.59 3.363 3.363 0 01-4.683 0m6.111.591l1.739 1.703a.711.711 0 01.19.697.729.729 0 01-.52.51.746.746 0 01-.711-.187l-1.772-1.736c-2.063 1.38-4.863.97-6.426-.94a4.62 4.62 0 01.46-6.35 4.855 4.855 0 016.497-.042 4.62 4.62 0 01.544 6.345z"
      }
    }), _c('path', {
      attrs: {
        "d": "M54.072 52.5c-.74 0-1.328-.606-1.311-1.328 0-.74.605-1.328 1.328-1.328.74 0 1.328.588 1.328 1.328 0 .353-.135.689-.387.94a1.391 1.391 0 01-.958.387z"
      }
    })])])]));
  }
};